import React from 'react';

import * as Styles from './styles';

export type TypographyVariant =
    | 'h1'
    | 'h2'
    | 'h3'
    | 'h4'
    | 'h5'
    | 'h6'
    | 'h7'
    | 'subheading1'
    | 'subheading2'
    | 'text'
    | 'primary'
    | 'secondary'
    | 'price'
    | 'innerHTML';

export interface ITypographyProps {
    variant: TypographyVariant;
    children: React.ReactNode | string;
    className?: string;
    size?: number;
    weight?: number;
    color?: string;
    margin?: string;
    padding?: string;
}

const Typography: React.FC<ITypographyProps> = ({
    variant,
    children,
    className,
    size = 14,
    weight,
    color,
    margin,
    padding,
}: ITypographyProps): React.ReactElement => {
    const getVariantColor = () => {
        if (variant === 'secondary') return '#5b5675';
        return color || '#040222';
    };
    switch (variant) {
        case 'h1':
            return (
                <Styles.ExtAuiH1 className={className}>
                    {children}
                </Styles.ExtAuiH1>
            );

        case 'h2':
            return (
                <Styles.ExtAuiH2 className={className}>
                    {children}
                </Styles.ExtAuiH2>
            );

        case 'h3':
            return (
                <Styles.ExtAuiH3 className={className}>
                    {children}
                </Styles.ExtAuiH3>
            );

        case 'h4':
            return (
                <Styles.ExtAuiH4 className={className}>
                    {children}
                </Styles.ExtAuiH4>
            );

        case 'h5':
            return (
                <Styles.ExtAuiH5 className={className}>
                    {children}
                </Styles.ExtAuiH5>
            );

        case 'h6':
            return (
                <Styles.ExtAuiH6 className={className}>
                    {children}
                </Styles.ExtAuiH6>
            );

        case 'h7':
            return (
                <Styles.ExtAuiH7 className={className}>
                    {children}
                </Styles.ExtAuiH7>
            );

        case 'price':
            return (
                <Styles.ExtAuiPrice className={className}>
                    {children}
                </Styles.ExtAuiPrice>
            );

        case 'subheading1':
            return (
                <Styles.ExtAuiSubHeading className={className}>
                    {children}
                </Styles.ExtAuiSubHeading>
            );

        case 'subheading2':
            return (
                <Styles.SubHeading2 className={className}>
                    {children}
                </Styles.SubHeading2>
            );

        case 'innerHTML':
            return (
                <Styles.InnterHTML
                    className={className}
                    dangerouslySetInnerHTML={{
                        __html: children as string,
                    }}
                />
            );

        case 'primary':
        case 'secondary':
        default:
            return (
                <Styles.ExtAuiText
                    className={className}
                    size={size}
                    weight={weight}
                    variant={variant}
                    margin={margin}
                    padding={padding}
                    color={getVariantColor()}
                >
                    {children}
                </Styles.ExtAuiText>
            );
    }
};

export default Typography;
